import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7db50a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubTournamentCreation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Create Club Tournaments", -1))
const _hoisted_3 = { class: "clubTournamentContainer" }
const _hoisted_4 = { class: "layout gutter--lg clubTournamentInfoContainer" }
const _hoisted_5 = { class: "row justify--space-around align--center" }
const _hoisted_6 = { class: "flex md6 xs6" }
const _hoisted_7 = { class: "flex md6 xs6" }
const _hoisted_8 = { class: "row justify--space-around align--center" }
const _hoisted_9 = { class: "flex md6 xs6" }
const _hoisted_10 = { class: "flex md6 xs6" }
const _hoisted_11 = { class: "row justify--space-around align--center" }
const _hoisted_12 = { class: "flex md6 xs6" }
const _hoisted_13 = { class: "flex md6 xs6" }
const _hoisted_14 = { class: "row justify--space-around align--center" }
const _hoisted_15 = { class: "flex md6 xs6" }
const _hoisted_16 = { class: "flex md6 xs6" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Select Player")
const _hoisted_18 = { class: "playerContainer" }
const _hoisted_19 = { class: "flex md1" }
const _hoisted_20 = { class: "center" }
const _hoisted_21 = { class: "flex md5" }
const _hoisted_22 = { class: "flex md1" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "row justify--space-around align--center" }
const _hoisted_25 = { class: "flex md6 xs6" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Generate Tournament Matches")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md12 flex" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "mb-4",
    style: {"font-size":"1.2em"}
  }, "Turneringskampplanen")
], -1))
const _hoisted_28 = { class: "createTournamentSeasonMatchPlanEditModal" }
const _hoisted_29 = { class: "justify--center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { class: "text--center" }
const _hoisted_32 = { class: "justify--center" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = {
  class: "",
  style: {"display":"flex"}
}
const _hoisted_35 = {
  key: 0,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_36 = {
  key: 1,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_37 = {
  key: 2,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_38 = {
  key: 3,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_39 = {
  key: 4,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_40 = {
  key: 5,
  class: "md4 flex createTournamentSeasonMatchPlanEditModal"
}
const _hoisted_41 = { class: "md4 flex createTournamentSeasonMatchPlanEditModal" }
const _hoisted_42 = { class: "gutter--xl" }
const _hoisted_43 = { class: "row justify--center align--center" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_list_item = _resolveComponent("va-list-item")!
  const _component_va_list = _resolveComponent("va-list")!
  const _component_va_scroll_container = _resolveComponent("va-scroll-container")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_va_form, { ref: "form" }, {
          default: _withCtx(() => [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "text",
                    modelValue: _ctx.tournamentCategory,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tournamentCategory) = $event)),
                    label: "Category*",
                    readonly: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.tournamentRaekke,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tournamentRaekke) = $event)),
                    options: _ctx.tournamentRaekkeOptions,
                    "track-by": (v) => v.id,
                    "text-by": (v) => v.name,
                    label: "Raekke*",
                    searchable: "",
                    bordered: ""
                  }, null, 8, ["modelValue", "options", "track-by", "text-by"])
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "datetime-local",
                    modelValue: _ctx.tournamentStartDateTime,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tournamentStartDateTime) = $event)),
                    min: _ctx.todayStart,
                    max: _ctx.todayEnd,
                    label: "TournamentStartDateTime*"
                  }, null, 8, ["modelValue", "min", "max"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "number",
                    modelValue: _ctx.noOfHoursBetweenMatches,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.noOfHoursBetweenMatches) = $event)),
                    label: "No Of Hours Between Matches*"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.tournamentSeasonTextValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tournamentSeasonTextValue) = $event)),
                    options: _ctx.tournamentSeasonTextOptions,
                    "track-by": (v) => v.id,
                    "text-by": (v) => v.name,
                    label: "Sæson",
                    bordered: ""
                  }, null, 8, ["modelValue", "options", "track-by", "text-by"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_va_input, {
                    bordered: "",
                    type: "number",
                    modelValue: _ctx.tournamentRoundsMatches,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tournamentRoundsMatches) = $event)),
                    label: "No of Matches for each player*"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode(_component_it_divider),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.playerValue,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.playerValue) = $event)),
                    options: _ctx.playerOptions,
                    "track-by": (v) => v.id,
                    "text-by": (v) => v.name,
                    label: "Spillere",
                    searchable: "",
                    "stick-to-edges": "",
                    bordered: ""
                  }, null, 8, ["modelValue", "options", "track-by", "text-by"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_va_button, {
                    color: "success",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectPlayerForTournament())),
                    disabled: !_ctx.playerValue
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPlayers, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row justify--center"
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("p", _hoisted_20, _toDisplayString((index +1).toString() + '.'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", null, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.removePlayer(index)),
                        style: {"cursor":"pointer"}
                      }, [
                        _createVNode(_component_va_icon, {
                          name: "clear",
                          color: "danger"
                        })
                      ], 8, _hoisted_23)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_va_button, {
                    color: "success",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.generateTournamentMatches())),
                    disabled: _ctx.selectedPlayers.length < 3
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ])
    ]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.clubTournamentMatchesModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.clubTournamentMatchesModal) = $event)),
      size: "large",
      fixedLayout: true,
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      header: _withCtx(() => [
        _hoisted_27
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("h2", null, [
              _createElementVNode("p", _hoisted_31, "Række: " + _toDisplayString(_ctx.tournamentRaekke?.id !== 0 ? _ctx.tournamentRaekke.name : 'Club Raekke'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_va_scroll_container, {
              vertical: "",
              horizontal: "",
              color: "primary",
              style: {"max-height":"480px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tournamentMatchRounds, (tournamentMatchRound, roundInd) => {
                  return (_openBlock(), _createBlock(_component_va_list, {
                    key: roundInd,
                    style: {"padding":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_33, "Round No. " + _toDisplayString(roundInd + 1), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tournamentMatchRound, (tournamentMatch, matchInd) => {
                        return (_openBlock(), _createBlock(_component_va_list_item, { key: matchInd }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_34, [
                              (tournamentMatch?.date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createVNode(_component_va_input, {
                                      class: "md4",
                                      type: "datetime-local",
                                      modelValue: tournamentMatch.date,
                                      "onUpdate:modelValue": ($event: any) => ((tournamentMatch.date) = $event),
                                      label: "Tidspunkt for kamp",
                                      placeholder: "Dato & klokkeslæt",
                                      bordered: "",
                                      style: {"margin-bottom":"4px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_36, "-")),
                              (tournamentMatch?.homePlayer)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createVNode(_component_va_select, {
                                      class: "ml-2",
                                      modelValue: tournamentMatch.homePlayer,
                                      "onUpdate:modelValue": ($event: any) => ((tournamentMatch.homePlayer) = $event),
                                      options: _ctx.selectedPlayers,
                                      "track-by": (v) => v.id,
                                      "text-by": (v) => v.name,
                                      label: "Home Player",
                                      searchable: "",
                                      bordered: "",
                                      style: {"margin-bottom":"4px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "track-by", "text-by"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_38, "-")),
                              (tournamentMatch?.awayPlayer)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _createVNode(_component_va_select, {
                                      class: "ml-2",
                                      modelValue: tournamentMatch.awayPlayer,
                                      "onUpdate:modelValue": ($event: any) => ((tournamentMatch.awayPlayer) = $event),
                                      options: _ctx.selectedPlayers,
                                      "track-by": (v) => v.id,
                                      "text-by": (v) => v.name,
                                      label: "Away Player",
                                      searchable: "",
                                      bordered: "",
                                      style: {"margin-bottom":"4px"}
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "track-by", "text-by"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_40, "-")),
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_va_select, {
                                  class: "ml-2",
                                  modelValue: tournamentMatch.chalkerPlayer,
                                  "onUpdate:modelValue": ($event: any) => ((tournamentMatch.chalkerPlayer) = $event),
                                  options: _ctx.selectedPlayers.filter((player) => player.name !== 'Oversidder'),
                                  "track-by": (v) => v.id,
                                  "text-by": (v) => v.name,
                                  label: "chalker",
                                  searchable: "",
                                  bordered: "",
                                  style: {"margin-bottom":"4px"}
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "track-by", "text-by"])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            (_ctx.isMatchCreationStart)
              ? (_openBlock(), _createBlock(_component_LoadingButton, {
                  key: 0,
                  color: 'success'
                }))
              : (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  class: "btn mr-2",
                  onClick: _ctx.createTeamsAndMatchesClubTournament,
                  color: "success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_44
                  ]),
                  _: 1
                }, 8, ["onClick"])),
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "secondary",
              onClick: _ctx.resetVariables
            }, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}